module.exports = __webpack_public_path__ + "img/dyb@3x.0681c6c2.png";